import React from "react";
import LightText from "../../Assets/CSS/Text";

const ProfileInfo = ({ empData }) => {
    console.log("Received empData in ProfileInfo:", empData);
    const mobile = empData?.mobileNumber || "";
    const [countryCode, number] = mobile.split(" ");

    return (
        <div style={{ marginBottom: "100px" }}>

            <p style={LightText}>Here’s the basic information of candidate</p>

            {/* First Row */}
            <div className="row mb-3 mt-3">
                <div className="col-md-5">
                    <label className="form-label">First Name<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        value={empData?.firstName}
                        readOnly
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>

                <div className="col-md-5">
                    <label className="form-label">Last Name<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        value={empData?.lastName}
                        readOnly
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>
            </div>

            {/* Second Row */}
            <div className="row mb-3">
                <div className="col-md-5">
                    <label className="form-label">Designation <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        value={empData?.designation}
                        readOnly
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>

                <div className="col-md-5">
                    <label className="form-label">Department<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={empData?.departmentName}
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>
            </div>

            {/* Third Row */}
            <div className="row mb-3">
                <div className="col-md-5">
                    <label className="form-label">Date of Birth<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        value={empData?.dateOfBirth}
                        className="form-control"
                        readOnly
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>

                <div className="col-md-5">
                    <label className="form-label">Personal Email<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        value={empData?.personalEmail}
                        readOnly
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>
            </div>

            {/* Mobile */}
            <div className="mb-3 col-md-5">
                <label className="form-label">Mobile Number</label>
                <div className="input-group gap-2">

                    <select
                        className="form-select"
                        disabled
                        style={{ maxWidth: "100px", borderColor: "#C8C8C8", borderRadius: "10px" }}
                    >
                        <option value={countryCode}>{countryCode}</option>
                    </select>

                    <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={number}
                        style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProfileInfo;
